import { TravelTicketRoute } from './travel-ticket-route';

export type ProductCategoryContext =
  | VoucherProductContext
  | MembershipProductContext
  | TravelTicketProductContext
  | SupportProductContext
  | SoftwareProductContext
  | PaidContentProductContext;

export interface VoucherProductContext {
  category: 'VOUCHER';
}

export interface MembershipProductContext {
  category: 'MEMBERSHIP';
}

export interface TravelTicketProductContext {
  category: 'TRAVEL_TICKET';
  route: TravelTicketRoute | null;
}

export interface SupportProductContext {
  category: 'SUPPORT';
}

export interface SoftwareProductContext {
  category: 'SOFTWARE';
}

export interface PaidContentProductContext {
  category: 'PAID_CONTENT';
}
